/* unplugin-vue-components disabled */import script from "./CellCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./CellCard.vue?vue&type=script&lang=ts&setup=true"

import "./CellCard.vue?vue&type=style&index=0&id=7cd9e7ff&lang=less"

const __exports__ = script;

export default __exports__